module.exports = __webpack_public_path__ + "img/button4.f7d11abb.png";